import { combineReducers } from 'redux';
import { alertReducer } from './alertReduce';
import { loginUserReducer } from './authReducer';
import {rangeForcasting_Reducer} from './rangeForcasting_Reduce';



export const rootReducer = combineReducers({
    alert: alertReducer,
    userData: loginUserReducer,
    rangeForcasting: rangeForcasting_Reducer,
});